module.exports = __webpack_public_path__ + "pc/img/swiper_05.b341832c.jpg";